import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { LanguageIcon } from '@seedlang/icons';
import Text from 'components/text';
import { computed } from 'mobx';
import { uniq } from 'lodash';
import { withoutDigits } from '@seedlang/utils';
import { splitTextBySearchTerms } from 'utils/search_highlight';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: ${props => props.padding || '0 5px'};
`;

const SourceLine = styled.div`
  display: flex;
  align-items: center;
  > :first-child { flex-shrink: 0; }
  margin: ${props => props.margin || '2px 0'};
`;

@observer
class VocabSourceForUser extends React.Component {

  @computed get sources() {
    return this.props.sources || [];
  }

  @computed get hasMultipleLanguages() {
    if (!this.sources) return false;
    return uniq(this.sources.map(item => withoutDigits(item.source?.languageId))).length > 1;
  }

  renderHighlightedText = (text) => {
    const segments = splitTextBySearchTerms(text || '', this.props.highlightTerms);
    return segments.map((segment, index) => {
      if (!segment.highlighted) {
        return <React.Fragment key={`${segment.text}-${index}`}>{segment.text}</React.Fragment>;
      }

      return <strong key={`${segment.text}-${index}`}>{segment.text}</strong>;
    });
  }

  render() {
    return (
      <Wrapper
        padding={this.props.padding}
        onClick={this.props.onClick}
      >
        {
          this.sources && this.sources.map((item, index) => {
            const showLanguageIcon = !this.props.hideLanguageIcons && (this.props.showLanguageIcons || this.hasMultipleLanguages || withoutDigits(item.source?.languageId) !== withoutDigits(this.props.user?.languageId));
            
            return (
              <SourceLine key={item.id || index} margin={this.props.lineMargin}>
                {
                  showLanguageIcon &&
                    <LanguageIcon
                      languageId={item.source && item.source?.languageId}
                      translatedByAi={item.translatedByAi}
                    />
                }
                <Text
                  margin={this.props.hideLanguageIcons ? '0' : `0 0 0 ${this.props.flagTextGap || '3px'}`}
                  fontSize={item.source?.rightToLeftLanguage ? '22px' : this.props.fontSize || '14px'}
                >
                  {this.renderHighlightedText(`${item.source?.textForUser(this.props.user) || ''}${item.source?.displayGender ? this.props.genderAbbreviation : ''}`)}
                </Text>
              </SourceLine>
            );
          })
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(VocabSourceForUser);
